import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import _ from 'lodash';

import Select from '../../elements/Select';
import '../../../styles/scss/filters/sort-order.scss';

import { sortOrders } from '../../../configuration/sorting'
import { setSortOrder } from '../../../redux/actions/applySortOrder'
import { getSortOrder } from '../../../redux/reducers/sorting'

const SortOrder = () => {
  const dispatch = useDispatch();
  const currentSortOrder = useSelector(getSortOrder)

  const sortOrderOptions = _.map(sortOrders, (type) => type.label)

  function onChangeSortOrder(event) {
    const filterLabel = _.get(event, 'target.value');
    const sortOrderKey = _.findKey(
      sortOrders,
      (type) => type.label === filterLabel
    );
    if (sortOrderKey) {
      dispatch(setSortOrder(sortOrderKey));
    }
  }

  return (
    <div className="sort-order">
      <Select
        className="sort-order"
        onChange={onChangeSortOrder}
        options={_.map(sortOrderOptions, (option) => ({
          value: option,
          displayName: `Sort by: ${option}`,
        }))}
        value={_.get(sortOrders, `[${currentSortOrder}].label`)}
      />
    </div>
  );
};

export default SortOrder;
